import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { StatusService } from '../services/status.service';

@Directive({
  selector: '[apStatus]'
})
export class StatusDirective {

  @Input() apStatus: string = "";

  constructor(
    private el: ElementRef,
    private status: StatusService
    ) { }

  @HostListener('mouseenter') onMouseEnter() {
    this.status.setText(this.apStatus);
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.status.clear();
  }

  private highlight(color: string) {
    this.el.nativeElement.style.backgroundColor = color;
  }

}
